import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useCreateSchedule } from "@/features/calendar/hooks/use-schedules";
import { CalendarPlus } from "@phosphor-icons/react";
import { useState } from "react";
import { useTranslation } from "@/features/utils/i18n";
import { toast } from "sonner";
import { ScheduleForm, getBrowserTimezone } from "./schedule-form";

export const ScheduleDialog = () => {
  const { t } = useTranslation("schedules");
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [timezone, setTimezone] = useState(getBrowserTimezone());
  const [rrules, setRrules] = useState("");

  const createSchedule = useCreateSchedule();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await createSchedule.mutateAsync({
        name,
        timezone,
        rrules,
      });

      toast.success(t("messages.created"));
      setOpen(false);
      // Reset form
      setName("");
      setTimezone(getBrowserTimezone());
      setRrules("");
    } catch (error) {
      toast.error(
        error instanceof Error ? error.message : t("messages.createError"),
      );
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>
          <CalendarPlus className="h-4 w-4 mr-2" />
          {t("schedulesSection.create")}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t("createDialog.title")}</DialogTitle>
          <DialogDescription>{t("createDialog.description")}</DialogDescription>
        </DialogHeader>

        <ScheduleForm
          name={name}
          timezone={timezone}
          rrules={rrules}
          onNameChange={setName}
          onTimezoneChange={setTimezone}
          onRrulesChange={setRrules}
          onSubmit={handleSubmit}
          onCancel={() => setOpen(false)}
          submitLabel={t("form.create")}
          isSubmitting={createSchedule.isPending}
        />
      </DialogContent>
    </Dialog>
  );
};
